export const MAX_BROWSER_AUTOMATION_SCREENSHOT_BYTES = 5 * 1024 * 1024;

export function getBase64DecodedByteLength(base64: string): number {
  const padding = base64.endsWith('==') ? 2 : base64.endsWith('=') ? 1 : 0;
  return Math.floor((base64.length * 3) / 4) - padding;
}

export function capBrowserAutomationScreenshotBase64(
  screenshotBase64: string | undefined,
): string | undefined {
  if (!screenshotBase64) {
    return undefined;
  }

  if (
    getBase64DecodedByteLength(screenshotBase64) >
    MAX_BROWSER_AUTOMATION_SCREENSHOT_BYTES
  ) {
    return undefined;
  }

  return screenshotBase64;
}
